export default __webpack_public_path__ + "static/media/dettagli1.55c9d346.jpg";